import { notify } from '@ps-int/ps-components/src/notifications/slice';
import { call, put } from 'typed-redux-saga';

import { NOTIFICATIONS_MAP } from '../../../../shared/features/notifications/ps-notifications';
import { replace, SCREENS } from '../../../../shared/helpers/navigation';
import { disconnectConferenceAction } from '../../features/conference/slice';
import { DisconnectReason, NotificationId } from '../../types';
import { handleDisconnect } from './handle-disconnect';

export function* handleCloseRoom() {
    yield put(
        disconnectConferenceAction({
            source: DisconnectReason.CLOSE_ROOM,
        })
    );
    yield call(replace, SCREENS.CREATE_CALL, {});
    yield call(handleDisconnect);
    yield put(notify(NOTIFICATIONS_MAP[NotificationId.PERMISSIONS_CLOSE_ROOM]()));
}
